// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Alice",
  middleName: "Street",
  lastName: "UK",
  message: "Punk rock with hip hop influences from Newcastle upon Tyne.",
  icons: [
    {
      image: "fa-bandcamp",
      url: "https://alicestreet.bandcamp.com",
    },
    {
      image: "fa-instagram",
      url: "https://instagram.com/alicestreetuk",
    },
    {
      image: "fa-spotify",
      url: "https://open.spotify.com/artist/31J2a0KGKgHiVbmkKOdmeg",
    },
    {
      image: "fa-youtube",
      url: "https://youtube.com/@alicestreetuk",
    },
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: false,
  heading: "About Alice Street",
  imageLink: "", // Add a band photo here later, or leave blank for now
  imageSize: 375,
  message:
    "Alice Street is a punk rock band from Newcastle upon Tyne, UK, blending strong hip hop influences. Members: Miguel Santos, Sedric Lambrini, Keith Moonshine, Terry Pilsner. Catch us live at Little Buildings and other venues around the North East.",
  resume: "", // Not applicable, leave blank or link to EPK if you have one
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: false, // Hide default GitHub projects
  heading: "",
  gitHubUsername: "",
  reposLength: 0,
  specificRepos: [],
};

// Leadership SECTION
const leadership = {
  show: false,
  heading: "",
  message: "",
  images: [],
  imageSize: {
    width: "615",
    height: "450"
  }
};

// Performances SECTION
const performances = {
  show: true,
  heading: "Performances"
};

// SKILLS SECTION
const skills = {
  show: false, // Hide default skills
  heading: "",
  hardSkills: [],
  softSkills: [],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: false,
  heading: "Get In Touch",
  message:
    "Want to book Alice Street for a gig or get in touch? Drop us an email:",
  email: "alicestreetuk@gmail.com",
};

const experiences = {
  show: false,
  heading: "",
  data: []
}

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, repos, skills, leadership, getInTouch, experiences, performances };
